// extracted by mini-css-extract-plugin
module.exports = {"params":"Searchcrumb_params__1Nbkx","param":"Searchcrumb_param__C7DKV"};